import { FaArrowUp } from 'react-icons/fa';

export function ScrollTop() {
    return (
        <div id="kt_scrolltop" className="scrolltop">
            <span className="svg-icon">
                <FaArrowUp className="text-white" />
            </span>{' '}
        </div>
    );
}
